<template>
  <div class="delete-chat-confirm">
    <ElDialog
    v-model="isShow"
    :title="$t('whatsapp.dialog.tipTitle')"
    :width="412"
    destroy-on-close
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleCancel"
  >
    <div class="delete-chat-confirm__body">
      <img src="../img/warning.png" alt="warning" class="warning-icon">
      <p class="confirm-text">{{ $t('whatsapp.dialog.deleteChatConfirm') }}</p>
    </div>

    <template #footer>
      <div class="delete-chat-confirm__footer">
        <ElButton class="btn-cancel" size="small" @click="handleCancel">
          {{ $t('common.cancel') }}
        </ElButton>
        <ElButton
          class="btn-confirm"
          type="primary"
          size="small"
          @click="handleConfirm"
        >
          {{ $t('common.confirm') }}
        </ElButton>
      </div>
    </template>
  </ElDialog>
  </div>
</template>

<script>
import { WarningFilled } from "@element-plus/icons-vue";

export default {
  name: "DeleteChatConfirm",
  components: { WarningFilled },
  emits: ["confirm"],
  data() {
    return {
      isShow: false,
      roomId: null,
    };
  },
  methods: {
    open(roomId) {
      this.roomId = roomId;
      this.isShow = true;
    },
    handleCancel() {
      this.isShow = false;
      this.roomId = null;
    },
    handleConfirm() {
      this.$emit("confirm", this.roomId);
      this.isShow = false;
      this.roomId = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-chat-confirm {
  display: inline-block;
}

.delete-chat-confirm__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0 8px;

  .warning-icon {
    color: #f5222d;
    margin-bottom: 16px;
    width: 60px;
    height: 60px;
  }

  .confirm-text {
    margin: 0;
    font-size: 14px;
    color: #333;
    text-align: center;
  }
}

.delete-chat-confirm__footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding-top: 4px;

  .btn-cancel {
    min-width: 65px;
  }

  .btn-confirm {
    min-width: 65px;
    background: #1890ff !important;
  }
}
</style>
